/* global localStorage */
import ApiService from '@/common/api.service'
import JwtService from '@/common/jwt.service'
import User from '@/models/User'

import { LOGIN, LOGIN_GOOGLE, LOGOUT, CHECK_AUTH, RECOVERY_PASS, FECTH_AUTH } from '@/store/actions.type'
import { SET_AUTH, PURGE_AUTH, SET_ERROR, SET_LOCALSTORE } from '@/store/mutations.type'

const state = {
    errors: null,
    user: null,
    isAuthenticated: !!JwtService.getToken()
}

const getters = {
    currentUser(state) {
        return state.user
    },
    isAuthenticated(state) {
        return state.isAuthenticated
    },
    isAdmin(state){
        return state.user.admin
    }
}

const mutations = {
    [SET_ERROR](state, error) {
        state.errors = error
    },
    [SET_LOCALSTORE](state, user) {

        state.isAuthenticated = true
        state.user = User.from(user)
        state.errors = {}
        JwtService.saveToken(state.user.token)

        localStorage.setItem('analiticauser', JSON.stringify(state.user))
        localStorage.setItem('analiticatoken', user)

        if(state.user.rol === '1' || state.user.rol === '3') {
            state.user.admin = true
        }
    },
    
    [SET_AUTH](state, user) {
        state.isAuthenticated = true
        state.user = user
        state.errors = {}

        if(state.user.rol === '1' || state.user.rol === '3') {
            state.user.admin = true
        }
    },
    
    [PURGE_AUTH](state) {
        state.isAuthenticated = false
        state.user = {}
        state.errors = {}
        JwtService.destroyToken()
        localStorage.removeItem('analiticauser')
        localStorage.removeItem('analiticatoken')
    }
}

const actions = {
    [RECOVERY_PASS](context, email) {
        return ApiService.post('recoverypass', email)
    },
    [LOGIN] (context, credentials) {
        return new Promise((resolve) => {
            ApiService
            .post('auth', credentials)
            .then(({ data }) => {
                context.commit(SET_LOCALSTORE, data.token)
                resolve(data)
            })
            .catch(({ response }) => {
                context.commit(SET_ERROR, response.data.response)
                resolve(response.data.response)
            })
        })
    },
    [LOGIN_GOOGLE] (context, credentials) {
        return new Promise((resolve) => {
            ApiService
            .post('auth_google', credentials)
            .then(({ data }) => {
                context.commit(SET_LOCALSTORE, data.token)
                resolve(data)
            })
            .catch(({ response }) => {
                context.commit(SET_ERROR, response.data.response)
                resolve(response.data.response)
            })
        })
    },
    [FECTH_AUTH](context, data) {
        context.commit(SET_AUTH, data)
    },
    [LOGOUT](context) {
        context.commit(PURGE_AUTH)
    },
    [CHECK_AUTH](context) {
    if (JwtService.getToken()) {
        ApiService.setHeader()
        // ApiService
        //   .get('user')
        //   .then(({data}) => {
        //     context.commit(SET_AUTH, data.user)
        //   })
        //   .catch(({response}) => {
        //     context.commit(SET_ERROR, response.data.errors)
        //   })
        } else {
        context.commit(PURGE_AUTH)
        }
    }
}

export default {
    state,
    mutations,
    getters,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/auth.js